import { FaxStatuses } from 'generated/graphql-types';
import { FaxStatusOption } from 'src/app/pages/fax-register/models/fax-status-option.interface';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../select/eager-select/eager-select-reducer';
import { faxStatusOptionActions } from './fax-status-option.actions';

export const faxStatusOptionFeatureKey = 'faxStatusOptions';

export type FaxStatusOptionState = EagerSelectState<FaxStatusOption>;

const adapter = createEagerSelectAdapter<FaxStatusOptionState, FaxStatusOption>({
   featureKey: faxStatusOptionFeatureKey,
   selectId: (fax: FaxStatusOption) => {
      return fax.typeName ? fax.typeName : '';
   },
});

export const faxStatusOptionSelectors = adapter.getSelectors(filterStatusNameOption);

const initialState = adapter.getInitialState();

export const faxStatusOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   faxStatusOptionActions.search,
   faxStatusOptionActions.searchReset,
   faxStatusOptionActions.loadFromApi,
   faxStatusOptionActions.loadFromApiSuccess,
   faxStatusOptionActions.loadFromApiFailure
);

export function filterStatusNameOption<T extends FaxStatusOption>(
   types: T[],
   searchText: string | null | undefined
): T[] {
   const filteredOptions: T[] = Object.values(FaxStatuses)
      .filter((statusName) => {
         if (searchText) {
            return statusName.toLowerCase().includes(searchText.toLowerCase());
         } else {
            return true;
         }
      })
      .map((typeName) => {
         return { typeName } as T;
      });

   return filteredOptions;
}
